import { render, staticRenderFns } from "./VacationDays.vue?vue&type=template&id=5767632a&scoped=true"
import script from "./VacationDays.vue?vue&type=script&lang=js"
export * from "./VacationDays.vue?vue&type=script&lang=js"
import style0 from "./VacationDays.vue?vue&type=style&index=0&id=5767632a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767632a",
  null
  
)

export default component.exports